import { Button, Modal, Checkbox, Row, Col } from 'antd';
import { useState, useEffect, useRef, useMemo } from 'react';
import api from '../../../apis';

import { updateUserDetail,useLocalStorageListener,getUserDetail } from '../../../hooks/handleUserLocalStorage';

import Config from '../../../config';
import { useGlobalVariable } from '../../../context/GlobalVariableProvider';
import ReactTable from '../form-control/react-table';
import moment from 'moment';
import { get } from 'http';

const pdfUrl = Config.publicFileUrl;
interface Property {
    opened: boolean;
    children?: any;
    onClosed?: any;
    display?: any;
}

const TncModal = (props: Property) => {
    // const [cookies, setCookie] = useCookies(['user']);

    const [title, setTitle] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [agreeChecked, setAgreeChecked] = useState(false);
    const [pdfFullUrls, setPdfFullUrls] = useState([]);
    const [loading, setLoading] = useState(false);
    
    const [tncList, setTncList] = useState([]);
    const { showTnc, setShowTnc,setShowingTnc } = useGlobalVariable();

    const [currentTNC, setCurrentTNC] = useState(null);
    const [isCTNCModalOpen, setIsCTNCModalOpen] = useState(false);

    const [buttonLoading, setButtonLoading] = useState(false);
    
    // useEffect(() => {
    //     // alert('on enter');
    //     //logined
    //    // console.log('cookies', cookies);
    //     if (cookies.user) {
    //         setIsModalOpen(cookies.user?.show_tnc);
       
    //         //handleShowTnc(cookies.user);
    //       //  getTncList();
    //     }
    // }, []);

    
    useLocalStorageListener((localdata) => {
        let localUser = getUserDetail();
        if (localUser) {
     
            if(localUser.show_tnc){
                setIsModalOpen(localUser.show_tnc);
            }
        }
        
    });

    useEffect(() => {
        setShowingTnc(isModalOpen);
        if (isModalOpen == true) {
            getTncList();
        }
    }, [isModalOpen]);

    const getTncList = () => {
        setLoading(true);
        api.getTncDetail().then((result: any) => {
            setLoading(false);
            setPdfFullUrls([]);
           // console.log('result', result);
            if (result) {
              //  setTitle(result?.title);

                let list = result;

                let newList = [];
                for (let i = 0; i < list.length; i++) {
                    let title = result[i]?.title;
                    let fullUrl =
                        pdfUrl + result[i]?.file_content + '#toolbar=0&navpanes=0';

                    newList.push({...result[i], url: fullUrl });
                }

                setTncList(newList);

                // let fullUrl =
                //     pdfUrl + result?.file_content + '#toolbar=0&navpanes=0';


                //setPdfFullUrl(fullUrl);
                if(newList.length == 0) {
                    setIsModalOpen(false);
                }
              
            }

         

            let localUser = getUserDetail();

            let newcookies = localUser;
            newcookies.show_tnc = false;
            // setCookie('user', newcookies, { path: '/' });
            updateUserDetail(newcookies);

        });
    }

    

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onCheckboxChange = (e: any) => {
        // console.log('checked = ', e.target.checked);
        setAgreeChecked(e.target.checked);
    };

    const submitAgree = (currentTNC:any) => {
        setButtonLoading(true);
        //currentTNC
        let ids = [currentTNC.b_id]
        api.agreeTnc(ids).then((result: any) => {
           // console.log('result', result);
            if (result.status == 0) {
                setIsCTNCModalOpen(false);
                setButtonLoading(false);
                getTncList();
            }
        });
    };

    const tblColumns = useMemo(
        () => [
            {
                Header: 'Date',
                accessor: 'b_publish_date_start',
                Cell: (data: any) => {
                    if(!data.value) return;
                    return moment(data.value).format('yyyy-MM-DD HH:mm:ss');
                },
            },
            {
                Header: 'Title',
                accessor: 'title'
            },
            // {
            //     Header: 'Status',
            //     accessor: 'status'
            // },
            {
                Header: '',
                accessor: 'file_content',
                Cell: (data: any) => {
                  
                    if(!data.value) return;
                    let row = data.row.original;
                    
                    return (<>   <Button type="link" onClick={()=>handleAgreeTNCPDF(row)} >Click Here to Agree </Button></>)
                }
            },
         
        ],
        []
    );

    const handleAgreeTNCPDF = (row:any) => {
        setCurrentTNC(row);
        setIsCTNCModalOpen(true);
    }

    return (
        <>
            <Modal
                bodyStyle={{
                    overflowY: 'auto',
                    minHeight: '70vh',
                    maxHeight: '70vh',
                    minWidth: '80vw'
                }}
                title={title}
                open={isModalOpen}
                onCancel={handleCancel}
                width={'100vw'}
                okButtonProps={{ style: { display: 'none' } }}
            >
                <div style={{ position: 'relative', height: '100vh' }}>
                    {/* {
                    tncList.map((item, index) => {
                        return (
                            <div key={index}>
                                    <embed
                                    src={item.url}
                                    frameBorder="0"
                                    scrolling="auto"
                                    // height="100%"
                                    height="100%"
                                    width="100%"
                                ></embed>
                            </div>
                        );
                    })
                    } */}
                     <ReactTable
                        columns={tblColumns}
                        data={tncList}
                        loading={loading}
                        size='small'
                        borderSeparate={true}
                    />
            
                </div>
            </Modal>

            <Modal
                bodyStyle={{
                    overflowY: 'auto',
                    minHeight: '70vh',
                    maxHeight: '70vh',
                    minWidth: '80vw'
                }}
                title={<>{currentTNC && currentTNC.title}</>}
                open={isCTNCModalOpen}
                onCancel={()=>setIsCTNCModalOpen(false)}
                width={'100vw'}
                okButtonProps={{ style: { display: 'none' } }}
                footer={[
                    <Row>
                        <Col span={24}>
                            <span className="text-danger">
                                *You must scroll to the bottom before you
                                can accept the terms
                            </span>{' '}
                            &nbsp; &nbsp;
                            <Button
                                type="primary"
                                disabled={!agreeChecked}
                                onClick={()=>submitAgree(currentTNC)}
                                loading={buttonLoading}
                            >
                                I AGREE
                            </Button>
                        </Col>
                    </Row>
                ]}
               
            >
                <div style={{ position: 'relative', height: '100vh' }}>
                    {
                        currentTNC &&
                        <embed
                            src={currentTNC.url + '#toolbar=0&navpanes=0'}
                            frameBorder="0"
                            scrolling="auto"
                            height="100%"
                            width="100%"
                        ></embed>
                    }
                    {/* {
                    tncList.map((item, index) => {
                        return (
                            <div key={index}>
                                    <embed
                                    src={item.url}
                                    frameBorder="0"
                                    scrolling="auto"
                                    // height="100%"
                                    height="100%"
                                    width="100%"
                                ></embed>
                            </div>
                        );
                    })
                    } */}
                    <Row justify="end">
                        <div className=' pb-5'>
                            <Checkbox onChange={onCheckboxChange}>
                                I accept the Terms and Conditions
                            </Checkbox>
                        </div>
                    </Row>
                </div>
            </Modal>
        </>
    );
};

export default TncModal;
